import {Injectable} from '@angular/core';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import {GroupsTotalModel} from '../../api/models/groups-total-model';
import {appColors} from '../../core/styles/colors';
import {ReportsService} from '../reports.service';

@Injectable()
export class GroupsDashboardService {

  public dashboardData: GroupsTotalModel = {
    grandTotals: [],
    totalsByGroup: [],
    totalsByTime: []
  };

  public selectedFilterType = {action: 99, text: 'Total Calls', field: 'all'};
  public filterTypes = [
    {action: 0, text: 'Groups Handled Calls', field: 'totalCalls'},
    {action: 1, text: 'Groups Answered Calls', field: 'answeredByUser'},
    {action: 2, text: 'Abandoned By Groups', field: 'missedCalls'},
    {action: 3, text: 'Active Agents', field: 'usersCount'},
    {action: 4, text: 'Total Calls', field: 'all'},
    {action: 5, text: 'Total Calls', field: 'all'},
    {action: 99, text: 'Total Calls', field: 'all'}
  ];

  public colors = appColors;

  constructor(private reportsService: ReportsService, private reportsApiService: ReportsApiService) {

  }
}
